<template>
  <div class="video-player">
    <videomuiPlayer :src="playerOptions.src"></videomuiPlayer>
  </div>
</template>

<script>
// import videomuiPlayer from "../../components/video/videomuiPlayer.vue";
export default {
  name: "GjkcH5School",
  components: {
    // videomuiPlayer,
  },

  data() {
    return {
      playerOptions: {
        src: "https://muiplayer.js.org/media/media.mp4", // 替换为你的实际视频链接
        autoplay: false,
        controls: true,
        // 其他配置选项
      },
      videourltime: {}, //传给组件的值
    };
  },

  mounted() {},

  methods: {
    onPlay() {
      console.log("视频播放中");
    },
    onPause() {
      console.log("视频暂停");
    },
    onEnded() {
      console.log("视频播放结束");
    },
  },
};
</script>
<style lang="scss" scoped>
.video-player {
  max-width: 762px;
  margin: auto;
}
</style>